import { Component } from "@opten/compiler/metadata/component";

@Component({ className: "js-my-fav-list" })
export class FavListComponent {
	constructor(private element: HTMLElement) {
		this.element.addEventListener("click", (event) => this.toggleButtons(event));

		const filterBtns = document.getElementsByClassName('js-filter-control');
		for (var i = 0; i < filterBtns.length; i++) {
			if (filterBtns[i].classList.contains('js-my-fav-list')) {
				continue;
			}
			filterBtns[i].addEventListener('click', (event) => this.toggleButtons(event));
		}
	}

	private toggleButtons(event: Event): void {
		const button = event.target as HTMLElement;
		if (button.tagName !== "A") {
			return;
		}

		var isActive = this.element.classList.contains('mixitup-control-active');
		var exporters = document.getElementsByClassName('js-my-fav-appear');
		for (var i = 0; i < exporters.length; i++) {
			if (!isActive) {
				exporters[i].classList.remove('hidden');
			}else {
				exporters[i].classList.add('hidden');
			}
		}
	}
}
